import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SiteChrome from "@/components/SiteChrome";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { useI18n } from "@/lib/i18n";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { usePlatformMessages } from "@/lib/usePlatformMessages";

export default function CompetitionLogin() {
  const { t } = useI18n();
  const { m } = usePlatformMessages();
  const { login } = useAuth();
  const nav = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/player/login", { username, password });
      login(data);
      toast.success(t("welcome") + " " + (data.name || ""));
      nav(`/lobby/${data.extra.game_id}`);
    } catch (err) {
      toast.error(err?.response?.data?.detail || m("login_error", null, t("login_error")));
    } finally {
      setLoading(false);
    }
  };

  return (
    <SiteChrome>
    <div className="min-h-screen bg-slate-50 font-[Nunito]">
      <div className="max-w-md mx-auto px-6 py-12">
        <h1 className="text-3xl font-[Fredoka] font-semibold text-slate-900 mb-2">{t("competition")}</h1>
        <p className="text-slate-500 mb-8">{t("login")}</p>
        <form onSubmit={submit} className="bg-white border border-slate-200 rounded-3xl p-8 space-y-4 shadow-sm" autoComplete="off">
          {/* Anti-autofill hidden dummies (Chrome ignores autocomplete=off otherwise) */}
          <input type="text" name="prevent-autofill" autoComplete="off" style={{ display: "none" }} />
          <input type="password" name="prevent-autofill-pw" autoComplete="new-password" style={{ display: "none" }} />
          <div>
            <Label>{t("username")}</Label>
            <Input
              data-testid="comp-username"
              placeholder="S12345678"
              value={username}
              onChange={(e) => setUsername(e.target.value.toUpperCase())}
              autoComplete="off"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck={false}
              name="supert-cred-user"
            />
          </div>
          <div>
            <Label>{t("password")}</Label>
            <Input
              data-testid="comp-password"
              placeholder="ABCD"
              maxLength={4}
              value={password}
              onChange={(e) => setPassword(e.target.value.toUpperCase())}
              autoComplete="new-password"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck={false}
              name="supert-cred-pass"
              type="text"
            />
          </div>
          <Button data-testid="btn-comp-login" type="submit" disabled={loading} className="w-full bg-rose-500 hover:bg-rose-600 rounded-full font-bold">
            {t("login")}
          </Button>
        </form>
      </div>
    </div>

    </SiteChrome>
  );
}
